import React, { useEffect, useState, useContext } from "react";
import { EnvironmentContext } from "../../EnvironmentContext";
import apiconfig from "../../config/config";
import { Toolbar, TextField } from "@mui/material";
import { DataGridComponent } from "../../Components/PaginationComponent";
import { useParams, } from "react-router-dom";
import { setEventDetails } from "../../Redux/Actions";
import { useDispatch, useSelector } from "react-redux";
import APIServices from "../../services/APIServices";
import OutlineButton from "../../Components/Button/Outlinebutton";
import ButtonCompo from "../../Components/ButtonComponent/ButtonCompo";
import moment from "moment-timezone";
import "moment-timezone/data/packed/latest.json";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import AlertComponent from "../../Components/Alert/Alert";
import "./EventInformation.css";
import DialogComponent from "../../Components/Dialog/Dialog";
import DialogComponentSingleBtn from "../../Components/Dialog/DialogComponentSingleBtn";
import { setAccessToken } from "../../Redux/Actions";
import { useNavigate } from "react-router-dom";

const EventInformation = () => {
  const { environment } = useContext(EnvironmentContext);
  const navigate = useNavigate
  const dispatch = useDispatch();
  const params = useParams();
  const eventId = params?.id;
  const [showModal, setShowModel] = useState(false)
  console.log(environment)
  moment.tz.add(
    "Asia/Calcutta|HMT BURT IST IST|-5R.k -6u -5u -6u|01232|-18LFR.k 1unn.k HB0 7zX0"
  );
  moment.tz.link("Asia/Calcutta|Asia/Kolkata");

  const eventDetails = useSelector((state) => state?.eventDetails);
  const allUsers = useSelector((state) => state.allUserDetails);

  const eventIdFromRedux = eventDetails?._id;
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [updateEvent, setUpdateEvent] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [profileId, setProfileId] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [randomNumber, setRandomNumber] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [bookingStatus, setBookingStatus] = useState(false);
  const [errAlert, setErrAlert] = useState(false);
  const [coHostStatus, setCoHostStatus] = useState(false)
  const [cancelEventStatus, setCancelEventStatus] = useState(false)
  const [addingUser, setAddingUser] = useState(false)
  const [slotCancelPopup, setSlotCancelPopup] = useState(false)
  const [waitListSlotPopup, setWaitlistSLotPopup] = useState(false);
  const [newSearchInput, setNewSearchINput] = useState('')
  const accessToken = useSelector((state) => state.accessToken);
  const adminDetails = useSelector((state) => state?.loginUserDetails);

  console.log("adminDetails: ", adminDetails)
  const adminMail = adminDetails?.mail
  const testingEnvironmentIds = {
    "support@meetbytravel.com": "669f4adac194ae7c8eb65d50",
    "jayadeep.mettela@ro-one.in": "665d4b21e27fc43df3215575"
  };

  const productionEnvironmentIds = {
    "support@meetbytravel.com": "669f4b370e0130ee414ef469",
    "jayadeep.mettela@ro-one.in": "66750b795ec6ba4ed5e33656"
  };

  let adminUserId;

  if (environment === "Production") {
    adminUserId = productionEnvironmentIds[adminMail];
  } else if (environment === "Testing") {
    adminUserId = testingEnvironmentIds[adminMail];
  }

  console.log("Environment:", environment);
  console.log("Admin Mail:", adminMail);
  console.log("Admin User ID:", adminUserId);

  // Handle undefined cases
  if (!adminUserId) {
    console.error("Admin User ID could not be determined.");
    // Optional: Provide a fallback or default behavior
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);
  useEffect(() => {
    const tokenLocal = JSON.parse(localStorage.getItem("token"));
    if (!accessToken && tokenLocal) {
      dispatch(setAccessToken(tokenLocal));
      APIServices.setAuthToken(tokenLocal);
    } else if (!accessToken && !tokenLocal) {
      navigate("/login");
    }
    if (accessToken || tokenLocal) {
      const tokenToUse = accessToken || tokenLocal;
      setIsLoading(true);
      APIServices.setAuthToken(tokenToUse);
      const url = environment === "Production"
        ? apiconfig.production.apiBaseUrl
        : apiconfig.develpoment.apiBaseUrl;
      APIServices.setApiBaseUrl(url);
      APIServices.getEventById(eventId, adminUserId)
        .then((response) => {
          dispatch(setEventDetails(response.data.event));
          setIsLoading(false);
        })
        .catch((err) => {
          console.log("Error fetching event details: ", err);
          setIsLoading(false);
          setErrAlert(true)
        });
    }
  }, [eventId, updateEvent, randomNumber, environment, dispatch, accessToken, navigate, adminUserId]);

  useEffect(() => {
    if (eventDetails?.participants) {
      const updatedRows = eventDetails?.participants.map((item, index) => ({
        id: index,
        attendee_name:
          item.full_name === null
            ? `${item?.first_name} ${item?.last_name}`
            : item?.full_name,
        user_status:
          item?.full_name !== null
            ? "Guest"
            : item?.co_organiser
              ? "Co-organiser"
              : "Traveller",
        reservation_date: moment(item?.booking_datetime[0]).format(
          "DD/MM/YYYY"
        ),
        booking_id: item?.booking_id,
        slot_Status: item?.slot_status,
        initial_slot_Status: item?.slot_status,
        co_host:
          item?.co_host_status === null
            ? "No"
            : item?.co_host_status === "requested" ||
              item?.co_host_status === "rejected"
              ? "No"
              : "Yes",
        co_host_status: item?.co_host_status,
        participant_id: item?._id,
        attended: item?.is_attended ? "Attended" : "Not Attended",
        user_id: item?.user_id?._id,
        refund_amount: item?.amount_paid,
        order_id: item?.order_id,
        email: item?.email,
        profile_id: item?.user_id?.profile_id,
        refund_status: item?.refund_status !== null && item?.refund_status !== undefined
          ? item?.refund_status
          : null,
      }));
      setRows(updatedRows);
    }
  }, [eventDetails]);

  useEffect(() => {
    const defaultColumns = [
      {
        field: "profile_id",
        headerName: "Profile ID",
        width: 200,
        cellClassName: "fullname-cell",
        headerClassName: "custom-header",
      },
      {
        field: "email",
        headerName: "Email",
        width: 270,
        cellClassName: "fullname-cell",
        headerClassName: "custom-header",
      },
      {
        field: "attendee_name",
        headerName: "Attendee Name",
        width: 200,
        cellClassName: "fullname-cell",
        headerClassName: "custom-header",
      },
      {
        field: "user_status",
        headerName: "User Status",
        width: 150,
        cellClassName: "fullname-cell1",
        headerClassName: "custom-header",
      },
      {
        field: "reservation_date",
        headerName: "Reservation Date",
        width: 150,
        cellClassName: "fullname-cell1",
        headerClassName: "custom-header",
      },
      {
        field: "booking_id",
        headerName: "Booking ID",
        width: 200,
        cellClassName: "fullname-cell1",
        headerClassName: "custom-header",
      },
      {
        field: "slot_Status",
        headerName: "Slot Status",
        width: 150,
        cellClassName: "fullname-cell",
        headerClassName: "custom-header",
        renderCell: (params) => {
          if (params.value === "cancelled") {
            return "Cancelled";
          }
          return <SlotStatusDropdown value={params.value} id={params.id} validationErrors={validationErrors} row={params.row} />;
        },
      },
      {
        field: "co_host",
        headerName: "Co-host",
        width: 150,
        renderCell: (params) => (
          <CoHostDropdown
            value={params.value}
            id={params.id}
            co_host_status={params.row}
          />
        ),
      },
      {
        width: 150,
        renderCell: (params) => {
          if ((params.row.refund_status === 'PROCESSING' || params.row.refund_status === "completed" || params.row.refund_status === "Pending") && (params.row.slot_Status === "cancelled")) {
            return <span style={{ fontFamily: 'Poppins', fontWeight: 'bold', color: 'green' }}>Refund initiated</span>;
          } else if (isEventEnd && params.row.slot_Status === "waiting") {
            return (
              <div className="refund-btn-container">
                <ButtonCompo btnText="Refund" onClick={() => handleApproveRefundAmount(params.row)} />
              </div>
            )
          } else {
            return null
          }
        },
      },

    ];

    setColumns(defaultColumns);
  }, [eventDetails]);


  const handleEditEvent = () => {
    const baseUrl = environment === "Production"
      ? "https://meetbytravel.com/viewevent/"
      : "https://dev.meetbytravel.com/viewevent/";

    window.open(`${baseUrl}${eventDetails?.ID_event}`, "_blank");
  };


  const handleApproveRefundAmount = (participant) => {
    setIsLoading(true);
    const body = {
      amount: participant?.refund_amount,
      orderId: participant?.order_id,
      eventId: eventDetails?._id,
      participantId: participant?.participant_id,
    };
    APIServices.waitListRefundAmount(body)
      .then((response) => {
        setRandomNumber(Math.random())
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Getting Error Wile Refund Process: ", err);
        setIsLoading(false);
      });
  };

  const handleCancelEvent = () => {
    const time = moment()
    setIsLoading(true);
    setShowModel(false)
    const currentDate = time.format('YYYY-MM-DD');
    const currentTime = time.format('HH:mm:ss');
    const body = {
      event_status: "cancelled",
      cancellationDatetime: [currentDate, currentTime]
    };
    APIServices.updateEvent(body, eventIdFromRedux, adminUserId)
      .then((response) => {
        setUpdateEvent(Math.random());
        setIsLoading(false);
        setCancelEventStatus(true);
      })
      .catch((err) => {
        console.log("Getting error while cancelling the event", err);
        setIsLoading(false);
        setErrAlert(true);
        setShowModel(false)
      });
  };

  const handleCancelTheEvent = () => {
    setShowModel(true)
  }

  const handleCloseCancel = () => {
    setShowModel(false)
  }

  const handleCloseSlotCancelPopup = () => {
    setSlotCancelPopup(false)
  }

  const handleCloseWaitlistPopup = () => {
    setWaitlistSLotPopup(false)
  }

  const handleCoHostChange = (event, id, value) => {
    const updatedRow = rows.find((row) => row.id === id);
    // console.log("updatedRow: ", updatedRow)

    if (updatedRow?.initial_slot_Status === "waiting") {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [id]: "Please confirm the slot to change co-host status.",
      }));
    } else {
      setIsLoading(true);
      const updatedRows = rows.map((row) =>
        row.id === id ? { ...row, co_host: event.target.value } : row
      );

      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [id]: null,
      }));

      // console.log("value: ", event.target.value);

      const body = {
        co_host_status: event.target.value === "No" ? "rejected" : "accepted",
      };
      // console.log("CoHostBody: ", body);

      APIServices.updateCoHostStatus(
        eventIdFromRedux,
        updatedRow?.participant_id,
        body,
        adminUserId
      )
        .then((response) => {
          setRows(updatedRows);
          dispatch(setEventDetails(response.data.getEvent));
          setIsLoading(false);
          setRandomNumber(Math.random());
          setCoHostStatus(true)
        })
        .catch((err) => {
          setIsLoading(false);
          setErrAlert(true)
          console.log("Error", err);
        });
    }
  };

  const calculateAmountToReserveSlot = (eventDetails, slotBookNumber) => {
    const organiserCost =
      eventDetails?.organizing_cost[0]?.organizer_fee === undefined
        ? 0
        : eventDetails?.organizing_cost[0]?.organizer_fee;
    const amountTopayToReserveSlot = (organiserCost / 100) * 22;
    const finalAmount = (amountTopayToReserveSlot * slotBookNumber).toFixed(2);
    return finalAmount;
  };

  const handleSlotStatusChange = (event, id, row) => {
    const updatedRows = rows.map((row) =>
      row.id === id ? { ...row, slot_Status: event.target.value } : row
    );
    setRows(updatedRows);
    const participantObject = row
    const userId = participantObject?.user_id
    const participantObjId = updatedRows.find(
      (row) => row?.id === id)?.participant_id;
    const body = {
      _id: participantObjId,
    };
    const updatedRow = updatedRows.find((row) => row.id === id);
    // console.log("updatedRow: ", updatedRow)

    const getAllGuests = eventDetails?.participants.filter((eachParticipant) => {
      return (eachParticipant?.user_id?._id === userId) && (eachParticipant.slot_status !== 'cancelled')
    })

    const getCancelledUserObject = getAllGuests.find((eachGuest) => {
      return participantObjId === eachGuest._id
    })
    const refundBody = {
      participants: [
        {
          participantId: participantObjId,
          slotStatus: "cancelled",
          cancellationDatetime: getCurrentDateAndTime(getTimeZone[eventDetails?.time_zone]),
          refund_amount: eventDetails?.organizing_cost?.length > 0
            ? calculateAmountToReserveSlot(eventDetails, getAllGuests.length) / getAllGuests.length
            : null,
          refund_status: eventDetails?.organizing_cost?.length > 0 ? "Pending" : null,
          confirmed_free_cancellation: true,
          waiting_free_cancellation: null,
        }
      ]
    };
    // console.log("getCancelledUserObject: ", refundBody)
    // console.log("getAllGuests: ", getAllGuests)

    const confirmSlots = (userId) => {
      let isRealUserConfirmed = false;
      for (const eachGuest of getAllGuests) {
        if (eachGuest.user_id._id === userId) {
          if (eachGuest.full_name === null && eachGuest.slot_status === "confirmed") {
            isRealUserConfirmed = true;
            break;
          }
        }
      }
      if (isRealUserConfirmed) {
        return true
      } else {
        return false
      }
    };

    if (getCancelledUserObject?.slot_status === "waiting" && updatedRow?.slot_Status === 'confirmed') {
      if (getCancelledUserObject?.full_name === null) {
        setIsLoading(true);
        APIServices.moveWaitlist(eventIdFromRedux, body, adminUserId)
          .then((response) => {
            dispatch(setEventDetails(response.data.getEvent));
            setIsLoading(false);
            setRandomNumber(Math.random());
            setBookingStatus(true)
          })
          .catch((err) => {
            setIsLoading(false);
            setRandomNumber(Math.random());
            console.log("Error calling move waitlist api", err);
            setErrAlert(true)
          });
      } else {
        setIsLoading(true);
        if (confirmSlots(getCancelledUserObject?.user_id?._id)) {
          APIServices.moveWaitlist(eventIdFromRedux, body, adminUserId)
            .then((response) => {
              dispatch(setEventDetails(response.data.getEvent));
              setIsLoading(false);
              setRandomNumber(Math.random());
              setBookingStatus(true)
            })
            .catch((err) => {
              setIsLoading(false);
              setRandomNumber(Math.random());
              console.log("Error calling move waitlist api", err);
              setErrAlert(true)
            });
        } else {
          // console.log("Unable to conform the slots for guest")
          setWaitlistSLotPopup(true)
          setRandomNumber(Math.random());
        }
      }
      // console.log("getAllGuests: ", getCancelledUserObject)
    } else {
      setIsLoading(true);
      if (getCancelledUserObject?.full_name !== null) {
        // console.log("Able to Cancel")
        APIServices.cancelReservation(eventIdFromRedux, refundBody, adminUserId)
          .then((response) => {
            setIsLoading(false);
            setRandomNumber(Math.random());
            setBookingStatus(true)
          })
          .catch((err) => {
            setIsLoading(false);
            setErrAlert(true)
            setRandomNumber(Math.random());
            console.log("Error in cancellation api", err);
          });
      } else {
        if (getAllGuests.length === 1) {
          // console.log("Able to Cancel")
          APIServices.cancelReservation(eventIdFromRedux, refundBody, adminUserId)
            .then((response) => {
              setIsLoading(false);
              setRandomNumber(Math.random());
              setBookingStatus(true)
            })
            .catch((err) => {
              setIsLoading(false);
              setErrAlert(true)
              setRandomNumber(Math.random());
              console.log("Error in cancellation api", err);
            });
        } else {
          setSlotCancelPopup(true)
          // console.log("unable to Cancel")
          setRandomNumber(Math.random());
        }
      }
    }
  };

  const checkIsEventEnd = () => {
    const tripEndDate = eventDetails?.end_date;
    const tripEndTime = eventDetails?.end_time;
    const eventTimeZone = eventDetails?.time_zone;
    let convertedTimeZone = eventTimeZone;

    if (eventTimeZone === "IST") {
      convertedTimeZone = "Asia/Kolkata";
    }
    const eventEndStatus = moment.tz(
      tripEndDate + " " + tripEndTime,
      "YYYY-MM-DD HH:mm",
      convertedTimeZone
    );

    const currentDateAndTime = moment.tz(convertedTimeZone);
    if (eventDetails?.event_status === 'cancelled') {
      return false
    } else {
      return currentDateAndTime.isAfter(eventEndStatus);
    }
  };

  const eventTimeZone = eventDetails?.time_zone;
  let convertedTimeZone = eventTimeZone;

  if (eventTimeZone === "IST") {
    convertedTimeZone = "Asia/Kolkata";
  }
  const isEventStarted = moment.tz(
    eventDetails?.start_date + " " + eventDetails?.start_time,
    "YYYY-MM-DD HH:mm",
    convertedTimeZone
  );

  const currentDate = moment.tz(convertedTimeZone);

  const isTripIsOnGoing = () => {
    if (eventDetails?.event_status === 'cancelled') {
      return false
    } else {
      if (currentDate.isBefore(isEventStarted)) {
        return false;
      } else {
        return true;
      }
    }
  };

  const isCancelledTrip = () => {
    if (eventDetails?.event_status === "cancelled") {
      return true
    }
    else {
      return false
    }
  }

  const isEventEnd = checkIsEventEnd();
  const isTripStarted = isTripIsOnGoing();
  const isCancelled = isCancelledTrip()

  const CoHostDropdown = ({ value, id, co_host_status }) => {
    const { user_status, slot_Status } = co_host_status;
    if (user_status === "Guest" || slot_Status === "cancelled") {
      return null;
    }
    return (
      <select
        className="text-black"
        value={value}
        onChange={(event) => handleCoHostChange(event, id, value)}
        disabled={isEventEnd}
      >
        <option style={{ color: "#595959" }} value="Yes">
          Yes
        </option>
        <option style={{ color: "#595959" }} value="No">
          No
        </option>
      </select>
    );
  };

  const SlotStatusDropdown = ({ value, id, validationErrors, row }) => {
    const hasError = validationErrors[id];
    return (
      <div>
        {value === 'confirmed' ? (
          <select
            className="text-black"
            value={value}
            onChange={(event) => handleSlotStatusChange(event, id, row)}
            disabled={isEventEnd}
            style={{
              width: "100%",
              fontFamily: "Poppins",
              borderColor: hasError ? "red" : "inherit",
              border: "none",
            }}
          >
            <option style={{ color: "#595959" }} value="confirmed">
              Confirmed
            </option>
            <option style={{ color: "#595959" }} value="cancelled">
              Cancelled
            </option>
          </select>
        ) : (
          <select
            className="text-black"
            value={value}
            onChange={(event) => handleSlotStatusChange(event, id, row)}
            disabled={isEventEnd}
            style={{
              width: "100%",
              fontFamily: "Poppins",
              borderColor: hasError ? "red" : "inherit",
              border: "none",
            }}
          >
            <option style={{ color: "#595959" }} value="confirmed">
              Confirmed
            </option>
            <option style={{ color: "#595959" }} value="waiting">
              Waiting list
            </option>
            <option style={{ color: "#595959" }} value="cancelled">
              Cancelled
            </option>
          </select>
        )}
        {hasError && (
          <p style={{ color: "red", marginTop: "4px" }}>{hasError}</p>
        )}
      </div>
    );
  };

  const getCurrentDateAndTime = (targetTimeZone) => {
    const currentDate = new Date();
    const options = {
      timeZone: targetTimeZone,
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: false,
    };

    const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
      currentDate
    );
    const dateAndTime = formattedDate?.split(",");
    const datePart = dateAndTime?.[0]?.split("/");
    const timePart = dateAndTime?.[1];
    const day = datePart?.[1];
    const month = datePart?.[0];
    const year = datePart?.[2];

    if (0 <= month && month <= 9 && 0 <= day && day <= 9) {
      return [`${year}-0${month}-0${day}`, timePart];
    } else if ((0 <= month && month <= 9) || (0 <= day && day <= 9)) {
      if (0 <= month && month <= 9) {
        return [`${year}-0${month}-${day}`, timePart];
      } else {
        return [`${year}-${month}-0${day}`, timePart];
      }
    } else {
      return [`${year}-${month}-${day}`, timePart];
    }
  };

  const getTimeZone = {
    IST: "Asia/Calcutta",
    CET: "Europe/Berlin",
  };

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    if (name === "profileId") setProfileId(value);
    if (name === "email") setEmail(value);
    if (name === "firstName") setFirstName(value);
    if (name === "lastName") setLastName(value);
  };

  const searchButtonClicked = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // const filtered = allUsers.filter((user) => {
    //   const userProfileId = user.profile_id?.toString() || "";
    //   const userEmail = user.email || "";
    //   const userFirstName = user.firstName || "";
    //   const userLastName = user.lastName || "";

    //   return (
    //     (profileId ? userProfileId.includes(profileId) : true) &&
    //     (email ? userEmail.includes(email) : true) &&
    //     (firstName ? userFirstName.includes(firstName) : true) &&
    //     (lastName ? userLastName.includes(lastName) : true)
    //   );
    // });
    // setFilteredUsers(filtered);
    APIServices.getUserSeachQuery(newSearchInput)
      .then((response) => {
        const results = response.data.Results;
        // console.log('search res:', results)
        setFilteredUsers(results)
      })
      .catch((err) => {
        console.log("Error while searching for users:", err);
      });

  };

  const addUsersbuttonClicked = (user) => {
    setIsLoading(true);
    const body = {
      userId: user._id,
      userDetails: {
        first_name: user?.firstName,
        last_name: user?.lastName,
        email: user?.email,
        booking_datetime: getCurrentDateAndTime(
          getTimeZone[eventDetails?.time_zone]
        ),
      },
    };
    APIServices.adminAddUserSlot(body, eventIdFromRedux)
      .then((response) => {
        setIsLoading(false);
        setRandomNumber(Math.random());
        setAddingUser(true)
      })
      .catch((error) => {
        setIsLoading(false);
        setErrAlert(true)
        console.log("Getting Error While Adding User: ", error);
      });
  };
  const handleShareChatLink = () => {
    const chatLink = eventDetails.event_chat_link;

    if (chatLink) {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

      if (isMobile) {
        // Use whatsapp:// URL scheme for mobile devices
        const mobileChatLink = chatLink.replace(
          "https://web.whatsapp.com/",
          "whatsapp://"
        );
        window.location.href = mobileChatLink;
      } else {
        // Use the web URL for desktop
        window.open(chatLink, "_blank");
      }
    } else {
      console.error("No chat link available");
    }
  };

  const handleNewSearch = (event) => {
    setNewSearchINput(event.target.value)
  }
  // console.log("newSearchInput: ", newSearchInput)
  return (
    <>
      <div className="event-information-bg-container">
        <Backdrop
          sx={{
            color: "#ffffff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <AlertComponent
          open={bookingStatus}
          severity="success"
          onClose={() => setBookingStatus(false)}
          text="Booking slot status updated successfully."
        />
        <AlertComponent
          open={coHostStatus}
          severity="success"
          onClose={() => setCoHostStatus(false)}
          text="Cohost status updated successfully."
        />
        <AlertComponent
          open={cancelEventStatus}
          severity="success"
          onClose={() => setCancelEventStatus(false)}
          text="Event cancelled successfully."
        />
        <AlertComponent
          open={addingUser}
          severity="success"
          onClose={() => setAddingUser(false)}
          text="Traveller added successfully."
        />
        <AlertComponent
          open={errAlert}
          severity="error"
          onClose={() => setErrAlert(false)}
          text="Something went wrong.Please try again after sometime."
        />
        <DialogComponent
          open={showModal}
          title='Are you sure to cancel the event ?'
          rightBtnText="Cancel the event "
          leftBtnText="No"
          rightBtnClick={handleCancelEvent}
          leftBtnClick={handleCloseCancel}
          onClose={handleCloseCancel}
        />
        <DialogComponentSingleBtn
          open={slotCancelPopup}
          title="You can't cancel this user "
          leftBtnText="Close"
          // rightBtnClick={handleCancelEvent}
          leftBtnClick={handleCloseSlotCancelPopup}
          onClose={handleCloseSlotCancelPopup}
        />
        <DialogComponentSingleBtn
          open={waitListSlotPopup}
          title="You can't Conform this guest"
          leftBtnText="Close"
          // rightBtnClick={handleCancelEvent}
          leftBtnClick={handleCloseWaitlistPopup}
          onClose={handleCloseWaitlistPopup}
        />
        <div className="travellers-org-container-count">
          <div className="details-container">
            <div className="details-content-container">
              <h5 className="information-side-heading">Event ID</h5>
              <p className="information-content">{eventDetails?.ID_event}</p>
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading">Trip organisers</h5>
              <p className="information-content">{eventDetails?.organizers}</p>
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading">Trip posting date</h5>
              <p className="information-content">
                {moment(eventDetails?.event_created_at).format("DD/MM/YYYY")}
              </p>
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading">Trip start date</h5>
              <p className="information-content">
                {moment(eventDetails?.start_date).format("DD/MM/YYYY")}
              </p>
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading">Trip end date</h5>
              <p className="information-content">
                {moment(eventDetails?.end_date).format("DD/MM/YYYY")}
              </p>
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading">Start location</h5>
              <p className="information-content">
                {eventDetails?.start_location}
              </p>
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading">Trip destination</h5>
              <p className="information-content">{eventDetails?.destination}</p>
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading">Event tags</h5>
              <p className="information-content">
                {eventDetails?.trip_categories.join(", ")}
              </p>
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading">No of spots</h5>
              <p className="information-content">{eventDetails?.no_of_slots}</p>
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading">Trip title</h5>
              <p className="information-content">{eventDetails?.trip_title}</p>
            </div>
          </div>
          <div className="details-container">
            <div className="details-content-container">
              <h5 className="information-side-heading">Trip status</h5>
              <p className="information-content">
                {isEventEnd
                  ? "Finished"
                  : isTripStarted
                    ? "Ongoing"
                    : isCancelled
                      ? "Cancelled"
                      : "Upcoming"}
              </p>
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading">Estimated cost</h5>
              <p className="information-content">
                {/* {eventDetails.organizing_cost} */}
                {(eventDetails?.is_event_free &&
                  eventDetails?.disable_expenses) ||
                  (eventDetails?.disable_travel &&
                    eventDetails?.disable_accommodation &&
                    eventDetails?.disable_entry_tickets_and_activities &&
                    eventDetails?.disable_miscellaneous)
                  ? "There are no expenses to display"
                  : `${eventDetails?.total_cost?.[0]?.type_of_currency === "INR"
                    ? "INR"
                    : "€"
                  }
                ${eventDetails?.total_cost?.[0]?.total_amount}`}
              </p>
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading">Last reserve date</h5>
              <p className="information-content">
                {moment(eventDetails?.last_date_to_register[0]).format(
                  "DD/MM/YYYY"
                )}
              </p>
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading">Organising cost</h5>
              <p className="information-content">
                {eventDetails?.is_event_free
                  ? "Free Event"
                  : eventDetails?.organizing_cost[0]?.type_of_currency === "INR"
                    ? "INR"
                    : "€"}{" "}
                {eventDetails?.organizing_cost[0]?.organizer_fee}
              </p>
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading">Event chat link</h5>
              {eventDetails?.event_chat_link === "" ? (
                <p className="information-content">No chat link</p>
              ) : (
                <p
                  style={{
                    color: "#e34242",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  className="information-content"
                  onClick={handleShareChatLink}
                >
                  {eventDetails?.event_chat_link}
                </p>
              )}
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading">Meeting point</h5>
              <p className="information-content">{eventDetails?.meeting_point}</p>
            </div>
          </div>
        </div>
        <div className="buttons-container">
          {isEventEnd || isTripStarted ? (
            <ButtonCompo btnText='View Details' btnOutlined onClick={handleEditEvent} />

          ) : (
            <ButtonCompo btnText='View or edit more details' btnOutlined onClick={handleEditEvent} />
          )}
          {isCancelled ? (null) : isEventEnd ? null :
            !isTripStarted ? (
              <ButtonCompo btnText='Cancel event' greyOutlined onClick={handleCancelTheEvent} />
            )
              : null}
        </div>
        <main style={{ flexGrow: 1 }}>
          <Toolbar />
          <DataGridComponent columns={columns} rows={rows} />
        </main>

        {isEventEnd || isTripStarted ? null : (
          <div>
            <h3 className="add-participant-title">Add a participant</h3>
            {/* <div className="input-fields-profile mt-5">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label

                  style={{ fontFamily: "Poppins", fontSize: "14px" }}
                >
                  Profile Id
                </label>
                <TextField
                  name="profileId"
                  placeholder="Profile id"
                  size="small"
                  value={profileId}
                  onChange={handleSearchChange}
                  InputProps={{
                    style: {
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      marginTop: "4px",
                    },
                  }}
                />
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{ fontFamily: "Poppins", fontSize: "14px" }}
                >
                  Email ID
                </label>
                <TextField
                  name="email"
                  placeholder="Enter Email ID"
                  size="small"
                  value={email}
                  onChange={handleSearchChange}
                  InputProps={{
                    style: {
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      marginTop: "4px",
                    },
                  }}
                />
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{ fontFamily: "Poppins", fontSize: "14px" }}
                >
                  First name
                </label>
                <TextField
                  name="firstName"
                  placeholder="Enter first name"
                  size="small"
                  value={firstName}
                  onChange={handleSearchChange}
                  InputProps={{
                    style: {
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      marginTop: "4px",
                    },
                  }}
                />
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{ fontFamily: "Poppins", fontSize: "14px" }}
                >
                  Last name
                </label>
                <TextField
                  name="lastName"
                  placeholder="Enter last name"
                  size="small"
                  value={lastName}
                  onChange={handleSearchChange}
                  InputProps={{
                    style: {
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      marginTop: "4px",
                    },
                  }}
                />
              </div>

            </div> */}
            <p className="fullname-cell ">Search for users by profile Id, first name, last name, user status, email</p>
            <TextField
              name="Search"
              placeholder="Search"
              size="small"
              value={newSearchInput}
              onChange={handleNewSearch}
              InputProps={{
                style: {
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  marginTop: "4px",
                },
              }}
            />

            {newSearchInput.length >= 4 ? (
              <div className="search-button-container">
                <ButtonCompo
                  btnText="Search"
                  typeOfBtn="Submit"
                  onClick={searchButtonClicked}
                />
              </div>
            ) : (

              <div className="search-button-container">
                <ButtonCompo
                  btnText="Search"
                  typeOfBtn="Submit"
                  onClick={searchButtonClicked}
                  disabledButton={true}
                />
              </div>
            )}
            {filteredUsers.length === 0 ? null : (
              <div className="participants-table">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Profile ID</th>
                      <th>Email</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredUsers.map((user) => {
                      const participant = eventDetails.participants.find(
                        (participant) =>
                          participant.user_id?.email === user.email &&
                          participant.slot_status !== "cancelled"
                      );
                      // console.log("participant: ", participant);
                      const isEventCreator =
                        eventDetails.event_creator?.email === user.email;
                      const isButtonDisabled =
                        participant !== undefined || isEventCreator;
                      return (
                        <tr key={user._id}>
                          <td style={{ color: "#0B63F8" }}>{user.profile_id}</td>
                          <td>{user.email}</td>
                          <td>{user.firstName}</td>
                          <td>{user.lastName}</td>
                          <td>
                            <OutlineButton
                              buttonText="Add +"
                              disableButton={isButtonDisabled}
                              onClick={() => addUsersbuttonClicked(user)}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

      </div>

    </>
  );
};

export default EventInformation;
